import { useMutation } from 'apollo-3';

import { syncMPMyProgressTracker } from 'GraphQL/mutation/MyPath.mutation';

const useSyncMPMyProgressTracker = (props) => {
  const [sync, { data, loading, error, ...apolloUtils }] = useMutation(syncMPMyProgressTracker, {
    ...props,
  });

  return {
    mutate: sync,
    mpSyncMyProductTimelineProgresses: data?.mpSyncMyProductTimelineProgresses,
    loading,
    error,
    ...apolloUtils,
  };
};

export default useSyncMPMyProgressTracker;
